var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "notifications" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-exclamation-triangle" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("device.titles.notifications.form")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6 notification-preview" },
          [
            _c("img", {
              staticStyle: { "max-width": "340px" },
              attrs: { src: require("@/assets/img/galaxyS10.png") },
            }),
            _vm._v(" "),
            _c("Notification", {
              attrs: { description: _vm.description, title: _vm.title },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-6",
            staticStyle: { height: "calc(100% - 40px)" },
          },
          [
            _c("UiCard", [
              _c(
                "form",
                { staticClass: "form p-0" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-row row row-selectors",
                      class: { error: _vm.selectionError },
                    },
                    [
                      _c("div", { staticClass: "selector" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selection,
                              expression: "selection",
                            },
                          ],
                          attrs: { id: "all", type: "radio", value: "all" },
                          domProps: { checked: _vm._q(_vm.selection, "all") },
                          on: {
                            change: function ($event) {
                              _vm.selection = "all"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "selector-inner",
                            attrs: { for: "all" },
                          },
                          [
                            _c("i", { staticClass: "fa fa-mobile-phone" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("notification.allDevices"))),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "counter" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$tc(
                                    "notification.countDevices",
                                    _vm.dati.length,
                                    { count: _vm.dati.length }
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selector" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selection,
                              expression: "selection",
                            },
                          ],
                          attrs: {
                            id: "watching",
                            type: "radio",
                            value: "monitoring",
                          },
                          domProps: {
                            checked: _vm._q(_vm.selection, "monitoring"),
                          },
                          on: {
                            change: function ($event) {
                              _vm.selection = "monitoring"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "selector-inner",
                            attrs: { for: "watching" },
                          },
                          [
                            _c("i", { staticClass: "fa fa-eye" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("notification.monitoringDevices")
                                  ) +
                                  "\n                                    "
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tableColumn-tooltip-wrapper" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-info-circle warning-beepiz-remote-monitoring show",
                                    staticStyle: {
                                      "font-size": "1.2rem",
                                      "margin-left": "5px",
                                      cursor: "pointer",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tooltip top",
                                      staticStyle: {
                                        width: "250px",
                                        right: "-5px",
                                        top: "calc(100% + 12px)",
                                      },
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticStyle: {
                                            color: "#ffc107",
                                            "font-weight": "700",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "notification.tooltip.title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "notification.tooltip.content"
                                            )
                                          ) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "counter" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$tc(
                                    "notification.countDevices",
                                    _vm.datistate.length,
                                    { count: _vm.datistate.length }
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selector" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selection,
                              expression: "selection",
                            },
                          ],
                          attrs: {
                            id: "manual",
                            type: "radio",
                            value: "manual",
                          },
                          domProps: {
                            checked: _vm._q(_vm.selection, "manual"),
                          },
                          on: {
                            change: function ($event) {
                              _vm.selection = "manual"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "selector-inner",
                            attrs: { for: "manual" },
                          },
                          [
                            _c("i", { staticClass: "fa fa-list" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("notification.manualSelection"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "counter" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$tc(
                                    "notification.countDevices",
                                    _vm.notificationDatis.length,
                                    { count: _vm.notificationDatis.length }
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selection == "manual"
                    ? [
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("planning.form.profile"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _c("multiselect", {
                                staticClass: "from-top",
                                attrs: {
                                  id: "planningProfiles",
                                  multiple: true,
                                  "close-on-select": true,
                                  taggable: false,
                                  placeholder: "",
                                  options: _vm.profiles,
                                  label: "label",
                                  "track-by": "profileId",
                                },
                                on: {
                                  blur: _vm.modification,
                                  tag: _vm.modification,
                                  select: _vm.modification,
                                  remove: _vm.modification,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-inline-flex align-items-center",
                                            },
                                            [
                                              option.meta.icon
                                                ? _c("ProfileIcon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: option.meta.icon,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(option.label)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "tag",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-inline-flex align-items-center",
                                            },
                                            [
                                              option.meta.icon
                                                ? _c("ProfileIcon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: option.meta.icon,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(option.label)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  691982520
                                ),
                                model: {
                                  value: _vm.notificationProfiles,
                                  callback: function ($$v) {
                                    _vm.notificationProfiles = $$v
                                  },
                                  expression: "notificationProfiles",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.showErrors["label"] &&
                                        _vm.errors.has("label"),
                                      expression:
                                        "showErrors['label'] && errors.has('label')",
                                    },
                                  ],
                                  staticClass: "offset-4 form-input-error",
                                  on: {
                                    click: function ($event) {
                                      return _vm.hideError("label")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.errors.first("label")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("planning.form.group"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _c("multiselect", {
                                staticClass: "from-top",
                                attrs: {
                                  id: "planningGroups",
                                  multiple: true,
                                  "close-on-select": true,
                                  taggable: false,
                                  placeholder: "",
                                  options: _vm.groups,
                                  label: "label",
                                  "track-by": "id",
                                },
                                on: {
                                  blur: _vm.modification,
                                  tag: _vm.modification,
                                  select: _vm.modification,
                                  remove: _vm.modification,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.label)),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "tag",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.label)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  613307416
                                ),
                                model: {
                                  value: _vm.notificationGroups,
                                  callback: function ($$v) {
                                    _vm.notificationGroups = $$v
                                  },
                                  expression: "notificationGroups",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.showErrors["label"] &&
                                        _vm.errors.has("label"),
                                      expression:
                                        "showErrors['label'] && errors.has('label')",
                                    },
                                  ],
                                  staticClass: "offset-4 form-input-error",
                                  on: {
                                    click: function ($event) {
                                      return _vm.hideError("label")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.errors.first("label")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("planning.form.dati"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _c("multiselect", {
                                staticClass: "from-top",
                                attrs: {
                                  id: "planningDatis",
                                  multiple: true,
                                  "close-on-select": true,
                                  taggable: false,
                                  placeholder: "",
                                  options: _vm.datis,
                                  label: "label",
                                  "track-by": "id",
                                },
                                on: {
                                  blur: _vm.modification,
                                  tag: _vm.modification,
                                  select: _vm.modification,
                                  remove: _vm.modification,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.label)),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "tag",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "tag-content" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    option.label || option.name
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          option.from
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip bottom",
                                                    staticStyle: {
                                                      width: "140px",
                                                      bottom:
                                                        "calc(100% + 5px)",
                                                      right: "calc(50% - 14px)",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          option.fromObject
                                                            .name ||
                                                            option.fromObject
                                                              .label
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1801866415
                                ),
                                model: {
                                  value: _vm.notificationDatis,
                                  callback: function ($$v) {
                                    _vm.notificationDatis = $$v
                                  },
                                  expression: "notificationDatis",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.showErrors["label"] &&
                                        _vm.errors.has("label"),
                                      expression:
                                        "showErrors['label'] && errors.has('label')",
                                    },
                                  ],
                                  staticClass: "offset-4 form-input-error",
                                  on: {
                                    click: function ($event) {
                                      return _vm.hideError("label")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.errors.first("label")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-separator" }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row row" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v(_vm._s(_vm.$t("notification.title"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.title,
                          expression: "title",
                        },
                        { name: "validate", rawName: "v-validate" },
                      ],
                      staticClass: "form-input col",
                      attrs: {
                        "data-vv-as": _vm.$t("notification.title"),
                        "data-vv-rules": "required",
                        maxlength: "255",
                        name: "title",
                        type: "text",
                      },
                      domProps: { value: _vm.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.title = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showErrors["title"] &&
                              _vm.errors.has("title"),
                            expression:
                              "showErrors['title'] && errors.has('title')",
                          },
                        ],
                        staticClass: "form-input-error",
                        on: {
                          click: function ($event) {
                            return _vm.hideError("title")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.errors.first("title")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row row" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v(_vm._s(_vm.$t("notification.description"))),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.description,
                          expression: "description",
                        },
                        { name: "validate", rawName: "v-validate" },
                      ],
                      staticClass: "form-input col",
                      attrs: {
                        "data-vv-as": _vm.$t("notification.description"),
                        "data-vv-rules": "required",
                        maxlength: "250",
                        name: "description",
                      },
                      domProps: { value: _vm.description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.description = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-counter" }, [
                      _vm._v(_vm._s(_vm.description.length) + "/250"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showErrors["description"] &&
                              _vm.errors.has("description"),
                            expression:
                              "showErrors['description'] && errors.has('description')",
                          },
                        ],
                        staticClass: "form-input-error",
                        on: {
                          click: function ($event) {
                            return _vm.hideError("description")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.errors.first("description")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-separator" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("notification.sending_type"))),
                        ]),
                        _vm._v(" "),
                        _c("UiSwitch", {
                          attrs: {
                            value: !_vm.scheduler,
                            labelYes: _vm.$t("notification.sendNow"),
                            labelNo: _vm.$t("notification.sendSchedule"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.setScheduler(!$event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.scheduler
                    ? _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("notification.sending_timing"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("DatePicker", {
                                attrs: {
                                  min: _vm.nowDate,
                                  position: { v: "bottom", h: "left" },
                                },
                                model: {
                                  value: _vm.scheduleDate,
                                  callback: function ($$v) {
                                    _vm.scheduleDate = $$v
                                  },
                                  expression: "scheduleDate",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "mx-2" }, [
                                _vm._v(_vm._s(_vm.$t("global.at"))),
                              ]),
                              _vm._v(" "),
                              _c("ClockPicker", {
                                attrs: { position: { v: "bottom", h: "left" } },
                                model: {
                                  value: _vm.scheduleTime,
                                  callback: function ($$v) {
                                    _vm.scheduleTime = $$v
                                  },
                                  expression: "scheduleTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "Toolbar",
              { staticClass: "justify-content-start flex-row-reverse" },
              [
                _c(
                  "Btn",
                  {
                    class: ["primary ", { disabled: _vm.validIsDisabled }],
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.validForm($event)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("global.send")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("Btn", { class: "" }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.goBack()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "Btn",
                  { class: "default" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: "/parameters/notifications/",
                          tag: "span",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("device.notifications.btns.list"))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }